import { Component, Input,  OnInit ,  Output, EventEmitter} from '@angular/core';
import { LoginService } from './login.service';
import { ToastrService } from 'ngx-toastr';
import {Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';  

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
	email: any;
	password: any;
	resetpwdBlock: Boolean = false;
	resetpwdSuccessBlock: Boolean = false;
	emailError: String = '';
	passwordError: String = '';
	emailValidateError: String = '';
	resetemailValidateError: String = '';
	resetemailError: String = '';
	@Input() pwdBlock: Boolean;
	@Input() closeButton: Boolean;
	@Output()emitPass: EventEmitter<any> = new EventEmitter<any>();
  constructor(private loginService: LoginService, private toastr: ToastrService, private router: Router,public translate: TranslateService) { }

  ngOnInit() {
  }
  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}
  closefn() {
		this.pwdBlock = false;
		this.resetpwdBlock = false;
		this.resetpwdSuccessBlock = false;
		this.email = '';
		this.password = '';
	this.emitPass.emit();
    }
	resetPasswordBlockShow (){
		this.resetpwdBlock = true;
	}
	resetPassword() {
		console.log('this.emailthis.emailthis.email',this.email)
		if(this.email == '' || this.email == undefined){
			this.translate.get('Common.EmailRequired').subscribe((res: string) => {
				this.resetemailError = res;
			})
			//this.resetemailError = 'Email is required';
		}
		if(this.email) {
			if(this.validateEmail(this.email.trim()) == false){
				this.translate.get('Common.EnterValidEmail').subscribe((res: string) => {
					this.resetemailValidateError = res;
				})
				//this.resetemailValidateError = 'Please Enter valid email';
				this.resetemailError = '';
			}else {
				this.resetemailValidateError = '';
				this.resetemailError = '';
				const args = {
					email: this.email.trim()
				};
				this.loginService.resetPasswordMail(args).subscribe(data => {
					console.log("---resetPassword---",data);				 
					 if(data && data.status == false) {
						 //this.toastr.error('', data.info);
						if(data.info =='email_address_missing'){
							this.translate.get('Login.EmailMissing').subscribe((res: string) => {
						   this.toastr.error(res)
						   })
						}
						else if(data.info =='server_issue'){
							this.translate.get('Common.WrongMSG').subscribe((res: string) => {
						   this.toastr.error(res)
						   })
						}
						else{
							this.toastr.error('', data.info);
						}
					 }else {
						this.resetpwdBlock = false;
						this.resetpwdSuccessBlock = true;
					 }				
				});
			}
			
		}		
	}
	goToLogin() {
		this.pwdBlock = true;
		this.resetpwdBlock = false;
		this.resetpwdSuccessBlock = false;
	}
	login() {
		console.log("inside login->")
		this.resetemailValidateError = '';
		this.resetemailError = '';
		if(this.email == '' || this.email == undefined){
			this.translate.get('Common.EmailRequired').subscribe((res: string) => {
				this.emailError = res;
			})
			//this.emailError = 'Email is required';
		}else {
			this.emailError = '';
		}
		if(this.password == '' || this.password == undefined) {
			this.translate.get('Common.PasswordRequired').subscribe((res: string) => {
				this.passwordError = res;
			})
			//this.passwordError = 'Password is required';
		}else {
			this.passwordError = '';
		}	
		if(this.password && this.email) {
			if(this.validateEmail(this.email.trim()) == false) {
				this.translate.get('Common.EnterValidEmail').subscribe((res: string) => {
					this.emailValidateError = res;
				})
				//this.emailValidateError = 'Please Enter valid email';
				this.emailError = '';
			}else {
				this.emailError = '';
				this.passwordError = '';
				this.emailValidateError = '';
				const args = {
					email: this.email.trim(),
					password: this.password.trim()
				};
				this.loginService.login(args).subscribe(data => {
				
					console.log("---login---",data);				 
					 if(data && data.data && data.data.status == false) {
						 //this.toastr.error('', data.data.info);
						if(data.data.info =='invalid_password'){
						 	this.translate.get('Login.InvalidPassword').subscribe((res: string) => {
							this.toastr.error(res)
							})
						}
						else if(data.data.info =='email_address_missing'){
							this.translate.get('Login.EmailMissing').subscribe((res: string) => {
								this.toastr.error(res)
								})
						}
						else{
							this.toastr.error('', data.data.info);
						}
					 }else {
						 if(data.data && data.data.info){
							localStorage.setItem('user', JSON.stringify(data.data.info));
						}
						if(data.data && data.data.info && data.data.info.firstName){
                            localStorage.setItem('name', data.data.info.firstName);
						}	
						let userData = JSON.parse(localStorage.getItem("user"));
						//data.info.type 
						
                       if (userData && userData.email && userData.email.trim() == "admin@uib.ai") {
                         this.router.navigate(["/overview"]);
                       } else {
                         this.router.navigate(["/dashboard"]);
                       }
                       
                       
                       
                       
                       // }
                      // }
						
						/* const redirectUrl = this.loginService.redirectUrl ?
							this.loginService.redirectUrl : environment.dashboardPrefix + data.user_data.roles.menu_tab[0].path;
						this.router.navigate([redirectUrl]); */
					 }				
				});
			}			
		}		
	}

	currentYear() {
		return new Date().getFullYear();
	}
}
